import { useContext } from "react";
import BusinessContext from "../../contexts/business-context";
import ToastNotification from "../ui/toast-notification";

const FullScreenLayout = ({ children }) => {
  const { notificationContent } = useContext(BusinessContext);

  return (
    <>
      <div className="flex min-h-[100dvh] h-[100dvh] scrollbar-none relative">{children}</div>
      <ToastNotification
        message={notificationContent.message}
        heading={notificationContent.header}
        icon={notificationContent.icon}
        isVisible={notificationContent.showNotification}
      />
    </>
  );
};

export default FullScreenLayout;
